import { render, staticRenderFns } from "./CallCentreTickets.vue?vue&type=template&id=02379e31"
import script from "./CallCentreTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./CallCentreTickets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports